import config from 'player/config';

function handleErrors(response) {
    if (!response.ok) {
        return Promise.reject(response);
    }
    return response;
}

function makeFetch(url) {
    return fetch(url)
        .then(handleErrors)
        .then((response) => response.json());
}

export const APPNEXUS_PROVIDER_ID = 'appnexus';

export const assetAdditionalData = [
    'settings', 'chapters', 'cuePoints', 'externalId', 'barrels',
    'externalCategoryId', 'nextAsset', 'sourceFiles', 'subtitles',
    'metadata', 'access', 'tags', 'stories', 'playlist'
].join('|');

const api = (vendor, endpoint) => makeFetch(config.api.getUrl(vendor, endpoint));

/**
 * @param {string} path
 * @param {string} query
 * @returns {Promise<unknown>}
 */
export const relatedApi = ({ path, query }) => {
    const relatedApiUrl = config.api.relatedApiUrl.replace(/\/$/, '');

    return makeFetch(`${relatedApiUrl}/${path}?${query}`);
};

export default api;
